import * as mappers from '../data-layer/mappers'

export const useCareersDataLayer = () => {
  return {
    mappers
  }
}
